import React from 'react';
import { PdfList } from '../../pdf/PdfList';

export const UploadPreview = ({ blobUrl }) => {
    if (!blobUrl) return <div>Nothing to preview yet.</div>;

    const DisplayImage = () => (
        <>
        <span>Note: displayed against a black background for viewing.</span>
        <img
            alt='uploaded image'
            style={{ backgroundColor: 'black'}}
            src={blobUrl} />
        </>
    );

    return (
        <div>
            <h2>Document Preview</h2>
            {blobUrl.includes('tp-images') && DisplayImage()} 
            {blobUrl.includes('tp-legal-documents') && 
                <PdfList pdfUrl={blobUrl} pageHeight={700} />
            }
        </div>
    );
};

export default UploadPreview;
